<template>
	<div>this is signout component</div>
</template>

<script>
import { Auth } from 'aws-amplify';
export default {
	name: 'SignOut',
	data: () => ({
		form: '',
		username: '',
		password: '',
		apiRequest: false,
	}),
	beforeMount() {
		Auth.currentAuthenticatedUser().then(user => {
			this.user = user;
			//try logout user
			try {
				Auth.signOut();
			} catch (error) {
				console.error('error signing out: ', error);
			}
			//
		});
	},
};
</script>
